import { render } from "./ReportSupervisor.vue?vue&type=template&id=81663f40&scoped=true&ts=true"
import script from "./ReportSupervisor.vue?vue&type=script&lang=ts"
export * from "./ReportSupervisor.vue?vue&type=script&lang=ts"

import "./ReportSupervisor.vue?vue&type=style&index=0&id=81663f40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81663f40"]])

export default __exports__